<dx-popup
  [visible]="showModal"
  [title]="'PUBLISHING-MODE.ACTIVATE-PUBLISHING-MODE.TITLE' | translate"
  [width]="450"
  height="auto"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  (onHidden)="cancel()"
>
  <div>
    <p>{{ 'PUBLISHING-MODE.ACTIVATE-PUBLISHING-MODE.TEXT' | translate }}</p>
    <div class="action-container">
      <dx-button 
        [text]="'COMMON.CANCEL' | translate" 
        type="danger"
        stylingMode="contained"
        (onClick)="cancel()"
      ></dx-button>
      <dx-button 
        [text]="'COMMON.ACTIVATE' | translate" 
        type="normal"
        stylingMode="contained"
        (onClick)="activate()"
      ></dx-button>
    </div>
  </div>
</dx-popup>